export default "__VITE_ASSET__Dr_0r8z6__"